import { gql } from '@apollo/client'

export const IMPACT_DASHBOARD_GOALS = gql`
  query ImpactDashboardGoals(
    $activeOnly: Boolean
    $createdAtStart: DateTime
    $createdAtEnd: DateTime
    $goalId: String
    $nonprofitOrgId: Int!
  ) {
    goals(
      activeOnly: $activeOnly
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      goalId: $goalId
      nonprofitOrgId: $nonprofitOrgId
    ) {
      archivedAt
      category
      ChecklistItem {
        createdAt
        goalId
        dueDate
        id
        isCompleted
        linkText
        linkUrl
        owner {
          id
          firstName
          lastName
        }
        resourceId
        title
        updatedAt
      }
      createdAt
      description
      endDate
      id
      GoalUpdate {
        createdAt
        description
        id
        goalId
        lastUpdatedUser {
          id
          firstName
          lastName
        }
      }
      nonprofitOrgId
      metric
      owner {
        id
        firstName
        lastName
      }
      FunderOrgToSharedGoal {
        funderOrgId
        sharedAt
        goalId
        funderOrg {
          id
          name
        }
        isGoalSharedByFunder
        isGoalSharedByNonprofit
        archivedAt
      }
      startDate
      target
      templateLibraryId
      title
      type
      unitOfMeasurement
      updatedAt
    }
  }
`
